/**
 * Shape of the subset of a Bugsnag event that the filters below inspect.
 * Kept intentionally minimal so the filters stay pure and unit-testable
 * without pulling in the full @bugsnag/js runtime.
 */
export interface BugsnagErrorLike {
    errorMessage?: string;
}

export interface BugsnagEventLike {
    errors: BugsnagErrorLike[];
}

/**
 * Discard benign IndexedDB errors that occur when the browser closes the
 * database connection during page unload/navigation (e.g. the reload triggered
 * right after login). The @ngx-pwa/local-storage backend fires a pending
 * transaction against the closing connection, which is a non-actionable race
 * rather than a real fault.
 */
export function isClosingDbConnectionError(event: BugsnagEventLike): boolean {
    return event.errors.some(error => typeof error.errorMessage === 'string' && error.errorMessage.includes('The database connection is closing'));
}
